import { NavLink, useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import {
  ChartPieSlice, TrendUp, TrendDown, Car, FileText,
  Bank, Wallet, Users, SignOut, CurrencyCircleDollar, ChartBar, Gear, Package, Scales, Target,
} from "@phosphor-icons/react";

const nav = [
  { to: "/", label: "Gösterge Paneli", icon: ChartPieSlice, end: true },
  { to: "/gelir", label: "Gelirler", icon: TrendUp },
  { to: "/gider", label: "Giderler", icon: TrendDown },
  { to: "/nakit-akis", label: "Nakit Akışı", icon: Wallet },
  { to: "/finansman", label: "Finansman", icon: Bank },
  { to: "/envanter", label: "Envanter", icon: Package },
  { to: "/filo", label: "Filo Durumu", icon: Car },
  { to: "/sozlesmeler", label: "Sözleşmeler", icon: FileText },
  { to: "/arac-karliligi", label: "Araç Kârlılığı", icon: ChartBar },
  { to: "/karsilastirma", label: "Dönem Karşılaştırma", icon: Scales },
  { to: "/butce-analiz", label: "Bütçe vs Gerçekleşen", icon: Target },
];

export default function Layout({ children }) {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  const handleLogout = async () => {
    await logout();
    navigate("/login");
  };

  return (
    <div className="min-h-screen flex bg-[#FAFAFA]">
      {/* Sidebar */}
      <aside className="w-64 bg-[#09090B] text-zinc-300 flex flex-col fixed h-screen z-20" data-testid="sidebar">
        <div className="px-6 py-6 border-b border-zinc-800">
          <div className="flex items-center gap-2">
            <div className="w-8 h-8 bg-[#002FA7] flex items-center justify-center rounded-sm">
              <CurrencyCircleDollar size={20} weight="bold" className="text-white" />
            </div>
            <div>
              <div className="font-display font-extrabold text-white text-lg leading-none tracking-tight">FiloFinans</div>
              <div className="text-[10px] uppercase tracking-[0.2em] text-zinc-500 mt-1">Filo Yönetimi</div>
            </div>
          </div>
        </div>

        <nav className="flex-1 py-4 px-3 space-y-1 overflow-y-auto">
          {nav.map((n) => (
            <NavLink
              key={n.to}
              to={n.to}
              end={n.end}
              data-testid={`nav-${n.to === "/" ? "dashboard" : n.to.slice(1)}`}
              className={({ isActive }) =>
                `flex items-center gap-3 px-3 py-2.5 rounded-sm text-sm font-medium transition-colors duration-150 ${
                  isActive ? "bg-[#002FA7] text-white" : "text-zinc-400 hover:text-white hover:bg-zinc-800"
                }`
              }
            >
              <n.icon size={18} weight="bold" />
              {n.label}
            </NavLink>
          ))}
          {user?.role === "admin" && (
            <NavLink
              to="/kullanicilar"
              data-testid="nav-users"
              className={({ isActive }) =>
                `flex items-center gap-3 px-3 py-2.5 rounded-sm text-sm font-medium transition-colors duration-150 ${
                  isActive ? "bg-[#002FA7] text-white" : "text-zinc-400 hover:text-white hover:bg-zinc-800"
                }`
              }
            >
              <Users size={18} weight="bold" />
              Kullanıcılar
            </NavLink>
          )}
          {user?.role === "admin" && (
            <NavLink
              to="/ayarlar"
              data-testid="nav-settings"
              className={({ isActive }) =>
                `flex items-center gap-3 px-3 py-2.5 rounded-sm text-sm font-medium transition-colors duration-150 ${
                  isActive ? "bg-[#002FA7] text-white" : "text-zinc-400 hover:text-white hover:bg-zinc-800"
                }`
              }
            >
              <Gear size={18} weight="bold" />
              Ayarlar
            </NavLink>
          )}
        </nav>

        <div className="px-3 py-4 border-t border-zinc-800">
          <div className="px-3 py-2 mb-2">
            <div className="text-sm text-white font-medium truncate" data-testid="current-user-name">{user?.name}</div>
            <div className="text-[11px] text-zinc-500 truncate">{user?.email}</div>
            <span className="inline-block mt-1.5 text-[10px] uppercase tracking-wider font-semibold px-2 py-0.5 rounded-full bg-zinc-800 text-zinc-300">
              {user?.role === "admin" ? "Yönetici" : "Personel"}
            </span>
          </div>
          <button
            onClick={handleLogout}
            data-testid="logout-button"
            className="w-full flex items-center gap-3 px-3 py-2.5 rounded-sm text-sm font-medium text-zinc-400 hover:text-white hover:bg-zinc-800 transition-colors duration-150"
          >
            <SignOut size={18} weight="bold" />
            Çıkış Yap
          </button>
        </div>
      </aside>

      <main className="flex-1 ml-64 min-h-screen">{children}</main>
    </div>
  );
}
